import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { deleteWorkspace as deleteWorkspaceAction } from 'src/actions/workspaces';
import { handleAsyncActionResult } from 'src/lib/reduxUtils';
import useReduxPopupSystem from 'src/new_arch/hooks/useReduxPopupSystem';

const useDeleteWorkspace = ( { workspaceID }: { workspaceID: number } ) => {
	const dispatch = useDispatch();
	const popupSystem = useReduxPopupSystem();

	const deleteWorkspace = useCallback( () => handleAsyncActionResult(
		dispatch( deleteWorkspaceAction( workspaceID ) ),
		{ title: 'The workspace has been successfully deleted.' },
		{ title: 'There was an error deleting the workspace. Please try again later.' }
	), [ dispatch, workspaceID ] ) as () => Promise<void>;

	const onDeleteClicked = useCallback( () => {
		const description = 'By deleting the workspace you will lose all projects and assets within it '
		+ 'with no chance of recovery.\nAre you sure you want to delete the workspace?';

		popupSystem.showDangerConfirmationDialog( {
			title: 'Delete Workspace forever',
			description,
			checkboxDescription: 'I understand that I will lose all my projects and won\'t be able to recover them',
			acceptText: 'Delete Workspace',
			cancelText: 'Cancel',
			descriptionAlignment: 'center'
		} ).then( ( confirm: boolean ) => {
			if ( confirm ) { deleteWorkspace(); }

			popupSystem.hideConfirmationDialog();
		} );
	}, [ dispatch, workspaceID, deleteWorkspace, popupSystem ] );

	return {
		onDeleteClicked
	};
};

export default useDeleteWorkspace;
